//@ts-check
import QRCodeCard from "../../../utils/QrCodeCard";
import numberWithCommas from "../../../utils/numbersWithComma";
import { AiFillCopy } from "react-icons/ai";
import { Toaster } from "../../../utils/toaster";
import { APP_CONST } from "../../../config/const";

const FORMAT_TYPES = {
  text: "string",
  number: "number",
  qrCodeValue: "qrcode",
  image: "image",
};

const handleCopy = async (text) => {
  console.log("Copying text:", text);
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
  });
};

const RenderValue = ({ item }) => {
  switch (item?.format) {
    case FORMAT_TYPES.text:
      return (
        <div className="displaying-text-number">
          <div className="displaying-label">{`${item?.label}${
            item?.value && ":"
          }`}</div>
          <div className="displayng-text">{item?.value}</div>
          <div
            className="copyValue"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: "1rem",
            }}
          >
            <div
              onClick={() => handleCopy(item?.value)}
              style={{ cursor: "pointer" }}
            >
              <AiFillCopy size={18} />
            </div>
            {/* <div style={{ fontSize: "7px" }}>Click to copy code</div> */}
          </div>
        </div>
      );
    case FORMAT_TYPES.number:
      return (
        <div className="displaying-text-number">
          {" "}
          <div className="displaying-label">{`${item?.label} ${
            item?.value && ":"
          }`}</div>
          {item?.value && (
            <div className="displayng-text">
              {numberWithCommas(item?.value)}{" "}
            </div>
          )}
          <div
            className="copyValue"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: "1rem",
            }}
          >
            <div
              onClick={() => handleCopy(item?.value)}
              style={{ cursor: "pointer" }}
            >
              <AiFillCopy size={18} />
            </div>
            {/* <div style={{ fontSize: "7px" }}>Click to copy code</div> */}
          </div>
        </div>
      );
    case FORMAT_TYPES.qrCodeValue:
      return (
        <div className="orHeadingSection">
          <div className="label">{`${item?.label}`}</div>
          <div className="displaying-qrcode">
            <QRCodeCard text={item?.value} />
          </div>
        </div>
      );
    case FORMAT_TYPES.image:
      return (
        <div className="orHeadingSection">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="label">{`${item?.label}`}</div>
            <div
              className="copyValue"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginLeft: "1rem",
              }}
            >
              <div
                onClick={() => handleCopy(item?.value)}
                style={{ cursor: "pointer" }}
              >
                <AiFillCopy size={18} />
              </div>
              {/* <div style={{ fontSize: "7px" }}>Click to copy code</div> */}
            </div>
          </div>
          <div className="image-container">
            <img className="displayng-img" src={item?.value} />
          </div>
        </div>
      );
    default:
      return (
        <div className="">
          {" "}
          <div className="displaying-label">{`${item?.label}:`}</div>
          <div className="displayng-text">{item?.value}</div>
          <div
            className="copyValue"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginLeft: "1rem",
            }}
          >
            <div
              onClick={() => handleCopy(item?.value)}
              style={{ cursor: "pointer" }}
            >
              <AiFillCopy size={18} />
            </div>
            {/* <div style={{ fontSize: "7px" }}>Click to copy code</div> */}
          </div>
        </div>
      );
  }
};

const DisplayValues = ({ displayItems = [] }) => {
  return (
    <>
      {displayItems.length > 0 && (
        <div className={`display-values-section`}>
          {displayItems?.map((item, idx) => (
            <div key={idx} className="item">
              {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
              <RenderValue item={item} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DisplayValues;
